export const imageUpload = {
	addImage: "Adicionar imagem",
	removeImage: "Remover imagem carregada",
	formatInfo: "JPG ou PNG",
	ariaLabel: {
		uploadedImage: "Imagem do produto carregada",
	},
};
